<template>
  <div>
    <hr />
    <h3 style="">{{ sectionTitle }}</h3>
    <button
      class="mylisting-button dark-button mt-3 mb-3"
      @click="showAddObjectDialog()"
    >
      Add {{ name }}
    </button>
    <div v-for="(object, index) of data" :key="'ref' + index">
      <hr class="ref-separator" />
      <h5 style="font-weight: 600; margin-bottom: 0;">
        {{ object["first_name"] }} {{ object["last_name"] }}
        <img
          class="edit-button"
          src="../../assets/img/icons/edit_icon_simple.svg"
          @click="showEditObjectDialog(object, index)"
        />
      </h5>
      <DetailSectionRowLayout
        :modelData="object"
        :listFields="listFields"
        :listExcludeFields="keyTitles"
      />
    </div>
    <hr style="margin-bottom: 0;" />
    <ProfileSectionDialog
      :name="name"
      :listFields="listFields"
      :keyTitles="keyTitles"
      v-model="isShowObjectFormDialog"
      :data="object"
      :isAdd="isAddObjectDialog"
      @saved="handleUpdateObjects($event)"
    />
  </div>
</template>

<script>
import axios from "axios";
import DetailSectionRowLayout from "./DetailSectionRowLayout";
import ProfileSectionDialog from "./ProfileSectionDialog";
import { ACTION_TYPE } from "../../constants/custom-define-type";

/**
 * The component is used to show for the section like reference or experience or education
 * in the application form
 */
export default {
  props: {
    sectionTitle: String,
    name: String,
    listFields: Array,
    keyTitles: {
      type: Array,
      default: () => ["name"]
    },
    data: Array
  },
  components: {
    DetailSectionRowLayout,
    ProfileSectionDialog
  },
  data() {
    return {
      isShowObjectFormDialog: false,
      object: {},
      isAddObjectDialog: false,
      indexOfEdittingObject: 0
    };
  },
  methods: {
    showAddObjectDialog() {
      this.isAddObjectDialog = true;
      this.object = {};
      this.isShowObjectFormDialog = true;
    },
    showEditObjectDialog(ref, index) {
      this.indexOfEdittingObject = index;
      this.isAddObjectDialog = false;
      this.object = { ...ref };
      this.isShowObjectFormDialog = true;
    },
    handleUpdateObjects(actionType) {
      if (actionType === ACTION_TYPE.ADD) {
        this.data.push({ ...this.object, id: 0 });
      } else if (actionType === ACTION_TYPE.UPDATE) {
        this.data[this.indexOfEdittingObject] = this.object;
      } else if (actionType === ACTION_TYPE.DELETE) {
        this.data.splice(this.indexOfEdittingObject, 1);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/ApplicationSectionWithDialog.vue